import { createBasicSelector } from 'util/redux'
import { selectRequestByType } from 'ducks/requests/selectors'
import { buildFetchFolderCountsRequestKey } from '../utils/request'

export const selectFetchFolderCountsRequestForChannelId = createBasicSelector(
  (state, channelId) =>
    selectRequestByType(state, buildFetchFolderCountsRequestKey(channelId))
)
